<app-preloader *ngIf="isLoading"></app-preloader>
<div class="extract insurance mobile collapsed" [id]="indexDeal + 'insurance' + index">
  <!--!isInsuranceEdition  -->
  <div class="title" *ngIf="!modeEditionProposal">
    <div class="name">
      <label class="checkboxWrapper" [for]="'insurance' + index + 'deal' + indexDeal">
        <ng-container>
          <input
            type="checkbox"
            [id]="'insurance' + index + 'deal' + indexDeal"
            [(ngModel)]="form.isSelected"
            [disabled]="!form.payments || !form.payments.length || userId != authService.currentUserIds || !isEnabled || readOnlyActions"
            (click)="sendSelectedInsuranceEvent($event, index)"
          />
          <span class="checkmark"></span>
        </ng-container>
        <span class="description">{{ form.dealName }}</span>
      </label>

      <!-- LAS ACCIONES SE REEMPLAZAN POR EL MENÚ CONTEXTUAL MOBILE ... -->
      <!-- <div class="actions" *ngIf="userId == authService.currentUserIds">
        <a (click)="update.emit(index)" class="edit" tp="Editar seguro"></a>
        <a (click)="delete.emit(index)" class="delete" tp="Eliminar seguro">Eliminar</a>
      </div> -->

    </div>
    <div class="rorac" *ngIf="form.roRac">
      <span>RoRAC</span>
      <span>{{ form.roRac }}%</span>
    </div>

    <!-- INCLUIR ACCIONES EN MENÚ CONTEXTUAL MOBILE ... -->
    <!-- Menú Contextual Mobile -->
    @if(userId == authService.currentUserIds && !readOnlyActions){
      <div class="contextualMenuMobile" [ngClass]="{ active: !!menuRef() }">
        <a
          (click)="toggleMenuOptions($event, deal.id)"
          class="toggle"
          [id]="getId()"
          aria-haspopup="menu"
          aria-controls="menu-id"
          role="button"
          [attr.aria-expanded]="menuRef()"
        >
          Ver/Ocultar menu
        </a>
        <div
          appBackdropOverlay
          appOutSideClick
          [isActive]="!!menuRef()"
          [ignoreElements]="[getId()]"
          [activeTarget]="menuRef()"
          [currentTarget]="deal.id"
          (outSideClick)="closeMenuOptions()"
          style="z-index: 40"
          class="menuContent"
          role="menu"
          id="menu-id"
          aria-labelledby="menu-button"
        >
          <ul>
            <li role="menuitem">
              <a (click)="update.emit(index)" class="iconAndText edit" tabindex="0">Editar</a>
            </li>
            <li role="menuitem">
              <a (click)="delete.emit(index)" class="iconAndText delete" tabindex="0">Eliminar</a>
            </li>
          </ul>
        </div>
      </div>
    }
  </div>
  <div class="resume" *ngIf="!modeEditionProposal">
    <div class="row">
      <div>
        <span>Producto Financiero</span>
        <span>{{ financialCalculator.getFinancialProduct(form.financialProductType) }}</span>
      </div>
      <div>
        <span>Moneda</span>
        <span>{{ form.currencyType }}</span>
      </div>
    </div>

    <div class="row">
      <div>
        <span>Plazo</span>
        <span>{{ form.term }}</span>
      </div>
      <div>
        <span>Tipo de producto</span>
        <span>{{ financialCalculator.getProductType(form.productType) }}</span>
      </div>
    </div>
    <div class="row">
      <div>
        <span>Condición</span>
        <span>{{ financialCalculator.getClassificationType(form.classification) }}</span>
      </div>
      <div>
        <span>N° unidades</span>
        <span>{{ form.quantity }}</span>
      </div>
    </div>
    <div class="row">
      <div>
        <span>Precio</span>
        <span>{{ form.unitPriceWithoutTax | currency : '' : '' }}</span>
      </div>
      <div>
        <span>Enganche</span>
        <span>{{ form.downPayment | currency : '' : '' }}</span>
      </div>
    </div>
    <div class="row">
      <div>
        <span>Total</span>
        <span>{{ form.financialAmount | currency : '' : '' }}</span>
      </div>
    </div>
    <a class="accordionControl" (click)="viewInsurance(index)" tp="{{ collapsed ? 'Ver detalle' : 'Ocultar detalle' }}"
      ></a
    >
  </div>
  <div class="accordionWrapper">
    <div>
      <app-deal-view-mobile [deal]="form" [isManualInsurance]="true" [nameCompany]="nameCompany" />
    </div>
  </div>
</div>
